import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "order-page container-fluid pt-5" };
var _hoisted_2 = { class: "card mt-4" };
var _hoisted_3 = {
    key: 0,
    class: "card-body personal-data"
};
var _hoisted_4 = { class: "row" };
var _hoisted_5 = { class: "col-12 col-md-6 col-xl-4 py-2" };
var _hoisted_6 = {
    key: 0,
    class: "px-2"
};
var _hoisted_7 = {
    key: 1,
    class: "input-group"
};
var _hoisted_8 = { class: "col-12 col-md-6 col-xl-4 py-2" };
var _hoisted_9 = {
    key: 0,
    class: "px-2"
};
var _hoisted_10 = {
    key: 1,
    class: "input-group"
};
var _hoisted_11 = {
    key: 0,
    class: "text-muted px-3"
};
var _hoisted_12 = { class: "row" };
var _hoisted_13 = { class: "col-12 col-md-6 col-xl-4 py-2" };
var _hoisted_14 = {
    key: 0,
    class: "px-2"
};
var _hoisted_15 = {
    key: 1,
    class: "input-group"
};
var _hoisted_16 = { class: "col-12 col-md-6 col-xl-4 py-2" };
var _hoisted_17 = {
    key: 0,
    class: "px-2"
};
var _hoisted_18 = {
    key: 1,
    class: "input-group"
};
var _hoisted_19 = { class: "col-12 col-md-6 col-xl-4 py-2" };
var _hoisted_20 = {
    key: 0,
    class: "px-2"
};
var _hoisted_21 = {
    key: 1,
    class: "text-muted px-3"
};
var _hoisted_22 = {
    key: 2,
    class: "row justify-content-center mt-3"
};
var _hoisted_23 = { class: "card mt-4" };
var _hoisted_24 = {
    key: 0,
    class: "card-body subscription-data"
};
var _hoisted_25 = { class: "row" };
var _hoisted_26 = { class: "col-12 col-md-6 col-xl-3 py-2" };
var _hoisted_27 = {
    key: 0,
    class: "px-2"
};
var _hoisted_28 = { class: "col-12 col-md-6 col-xl-3 py-2" };
var _hoisted_29 = {
    key: 0,
    class: "px-2"
};
var _hoisted_30 = { class: "col-12 col-md-6 col-xl-3 py-2" };
var _hoisted_31 = {
    key: 0,
    class: "px-2"
};
var _hoisted_32 = { class: "card mt-4" };
var _hoisted_33 = {
    key: 0,
    class: "card-body payment-data"
};
var _hoisted_34 = { class: "mb-4" };
var _hoisted_35 = {
    class: "btn-group-toggle d-flex flex-wrap gap-3 justify-content-center",
    "data-toggle": "buttons"
};
var _hoisted_36 = { class: "row flex-column align-items-center py-2" };
var _hoisted_37 = {
    key: 1,
    class: "text-center text-white my-4"
};
var _hoisted_38 = {
    key: 2,
    class: "d-flex justify-content-center py-4"
};
var _hoisted_39 = ["href"];
var _hoisted_40 = {
    key: 3,
    class: "text-center text-white my-4"
};
var _hoisted_41 = {
    key: 4,
    class: "text-center"
};
var _hoisted_42 = {
    key: 1,
    class: "card-body"
};
var _hoisted_43 = { class: "row flex-column align-items-center" };
import { ref, onMounted } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import { getGroupsFromOrders, paypal, subscribe, updateProfile } from '@/api/public/client';
import { getProfileData } from '@/api/auth';
import CountrySelect from '@/components/CountrySelect.vue';
import moment from 'moment';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderPage',
    setup: function (__props) {
        var _this = this;
        moment.locale('es');
        var expiredAt = moment().add(30, 'days').format('DD/MMM/YYYY');
        var auth = useAuthStore();
        var orders = ref([]);
        var orderList = ref([]);
        var paymentMethod = ref(null);
        var profile = ref({
            username: '',
            firstname: '',
            lastname: '',
            email: '',
            phone: '',
            address: '',
            state: '',
            countryId: '',
            country: null,
        });
        var savedData = ref({
            firstname: '',
            lastname: '',
            email: '',
            state: '',
            countryId: '',
        });
        var showProfile = ref(false);
        var isDone = ref(false);
        var paypalUrl = ref(null);
        onMounted(function () {
            if (!auth.hasOrder()) {
                var savedOrder = localStorage.getItem('order');
                auth.orders = savedOrder ? JSON.parse(savedOrder) : [];
            }
            orders.value = auth.orders;
            getOrderList();
            getProfile();
        });
        var getOrderList = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getGroupsFromOrders(orders.value)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 201) {
                            orderList.value = response.data;
                            console.log('Lista de pedidos:', orderList.value);
                        }
                        else {
                            console.error('Error al cargar la lista de pedidos');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error al cargar la lista de pedidos.', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var getProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, jsonData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getProfileData()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            profile.value = response.data;
                            jsonData = JSON.parse(JSON.stringify(response.data));
                            savedData.value.firstname = jsonData.firstname;
                            savedData.value.lastname = jsonData.lastname;
                            savedData.value.email = jsonData.email;
                            savedData.value.state = jsonData.state;
                            savedData.value.countryId = jsonData.countryId;
                            showProfile.value = true;
                            //console.log('Perfil cargado:', savedData.value, jsonData);
                        }
                        else {
                            console.error('Error al cargar el perfil');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error al cargar el perfil', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var updateProfileSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, updateProfile(profile.value)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            getProfile();
                            //console.log('Perfil actualizado:', savedData.value);
                        }
                        else {
                            console.error('Error al actualizar el perfil');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error('Error al actualizar el perfil', error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var getPaypalUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, paypal({ id: orderList.value[0].id, amount: (_a = orderList.value[0]) === null || _a === void 0 ? void 0 : _a.cost_per_account })];
                    case 1:
                        response = _b.sent();
                        if (response.status === 201) {
                            paypalUrl.value = response.data.approvalUrl;
                        }
                        else {
                            console.error('Error al obtener la URL de PayPal');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _b.sent();
                        console.error('Error al obtener la URL de PayPal', error_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var selectMethod = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === 'paypal')) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getPaypalUrl()];
                    case 2:
                        response = _a.sent();
                        paymentMethod.value = type;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        paymentMethod.value = type;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        var handleSubscribe = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_5;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, subscribe({ groupId: orderList.value[0].id, cost: (_a = orderList.value[0]) === null || _a === void 0 ? void 0 : _a.cost_per_account })];
                    case 1:
                        response = _b.sent();
                        if (response.status === 201) {
                            isDone.value = true;
                        }
                        else {
                            notify('Error al suscribirse', 'danger', toast.POSITION.BOTTOM_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _b.sent();
                        notify('Error al suscribirse', 'danger', toast.POSITION.BOTTOM_CENTER);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "text-center" }, "Datos de la suscripción", -1)),
                _createElementVNode("div", _hoisted_2, [
                    (showProfile.value && orders.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Datos Personales", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (((_a = savedData.value.firstname) === null || _a === void 0 ? void 0 : _a.length) > 3)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
                                            _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Nombre(s):", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(profile.value.firstname), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((profile.value.firstname) = $event); }),
                                                placeholder: "Nombre(s)"
                                            }, null, 512), [
                                                [_vModelText, profile.value.firstname]
                                            ])
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    (((_b = savedData.value.lastname) === null || _b === void 0 ? void 0 : _b.length) > 3)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_9, [
                                            _cache[9] || (_cache[9] = _createElementVNode("dt", null, "Apellidos:", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(profile.value.lastname), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((profile.value.lastname) = $event); }),
                                                placeholder: "Apellidos"
                                            }, null, 512), [
                                                [_vModelText, profile.value.lastname]
                                            ])
                                        ]))
                                ])
                            ]),
                            (((_c = savedData.value.firstname) === null || _c === void 0 ? void 0 : _c.length) < 4 || ((_d = savedData.value.lastname) === null || _d === void 0 ? void 0 : _d.length) < 4)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Sus datos personales no han sido registrados, son necesarios para continuar con la compra. "))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    (((_e = savedData.value.email) === null || _e === void 0 ? void 0 : _e.length) > 3)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_14, [
                                            _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Correo electrónico:", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(profile.value.email), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((profile.value.email) = $event); }),
                                                placeholder: "Correo electrónico"
                                            }, null, 512), [
                                                [_vModelText, profile.value.email]
                                            ])
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    (((_f = savedData.value.state) === null || _f === void 0 ? void 0 : _f.length) > 3)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_17, [
                                            _cache[11] || (_cache[11] = _createElementVNode("dt", null, "Ciudad", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(profile.value.state), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((profile.value.state) = $event); }),
                                                placeholder: "Ciudad, Estado, Departamento o Municipio"
                                            }, null, 512), [
                                                [_vModelText, profile.value.state]
                                            ])
                                        ]))
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    (savedData.value.countryId !== null)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_20, [
                                            _cache[12] || (_cache[12] = _createElementVNode("dt", null, "País", -1)),
                                            _createElementVNode("dd", null, _toDisplayString((_g = profile.value.country) === null || _g === void 0 ? void 0 : _g.name), 1)
                                        ]))
                                        : (_openBlock(), _createBlock(CountrySelect, {
                                            key: 1,
                                            modelValue: profile.value.countryId,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((profile.value.countryId) = $event); })
                                        }, null, 8, ["modelValue"]))
                                ])
                            ]),
                            (((_h = savedData.value.email) === null || _h === void 0 ? void 0 : _h.length) < 4 || ((_j = savedData.value.state) === null || _j === void 0 ? void 0 : _j.length) < 4 || ((_k = savedData.value.countryId) === null || _k === void 0 ? void 0 : _k.length) < 4)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_21, " Sus datos de contacto son necesarios para comunicarnos contigo. "))
                                : _createCommentVNode("", true),
                            (((_l = savedData.value.firstname) === null || _l === void 0 ? void 0 : _l.length) <= 3 || ((_m = savedData.value.lastname) === null || _m === void 0 ? void 0 : _m.length) <= 3 || ((_o = savedData.value.email) === null || _o === void 0 ? void 0 : _o.length) <= 3 ||
                                ((_p = savedData.value.state) === null || _p === void 0 ? void 0 : _p.length) <= 3 || savedData.value.countryId === null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary",
                                        style: { "max-width": "250px" },
                                        onClick: updateProfileSubmit
                                    }, "Actualizar Datos")
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                    (showProfile.value && orders.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Datos de la suscripción", -1)),
                            _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    (orders.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_27, [
                                            _cache[14] || (_cache[14] = _createElementVNode("dt", null, "Grupo:", -1)),
                                            _createElementVNode("dd", null, _toDisplayString((_q = orderList.value[0]) === null || _q === void 0 ? void 0 : _q.groupName) + " | " + _toDisplayString((_s = (_r = orderList.value[0]) === null || _r === void 0 ? void 0 : _r.platform) === null || _s === void 0 ? void 0 : _s.name), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    (orders.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_29, [
                                            _cache[15] || (_cache[15] = _createElementVNode("dt", null, "Suscripción:", -1)),
                                            _createElementVNode("dd", null, "$us " + _toDisplayString((_t = orderList.value[0]) === null || _t === void 0 ? void 0 : _t.cost_per_account), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    (orderList.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("dl", _hoisted_31, [
                                            _cache[16] || (_cache[16] = _createElementVNode("dt", null, "Fecha de vencimiento:", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(_unref(expiredAt)), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                    (showProfile.value && orders.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-white" }, "Método de pago", -1)),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("label", {
                                        class: _normalizeClass(["btn btn-tab", { active: paymentMethod.value === 'meru' }]),
                                        onClick: _cache[5] || (_cache[5] = function ($event) { return (selectMethod('meru')); })
                                    }, _cache[18] || (_cache[18] = [
                                        _createElementVNode("img", {
                                            class: "img-fluid",
                                            src: "/imagenes/meru.svg"
                                        }, null, -1)
                                    ]), 2),
                                    _createElementVNode("label", {
                                        class: _normalizeClass(["btn btn-tab", { active: paymentMethod.value === 'paypal' }]),
                                        onClick: _cache[6] || (_cache[6] = function ($event) { return (selectMethod('paypal')); })
                                    }, _cache[19] || (_cache[19] = [
                                        _createElementVNode("img", {
                                            class: "img-fluid",
                                            src: "/imagenes/paypal.svg"
                                        }, null, -1)
                                    ]), 2),
                                    _createElementVNode("label", {
                                        class: _normalizeClass(["btn btn-tab", { active: paymentMethod.value === 'crypto' }]),
                                        onClick: _cache[7] || (_cache[7] = function ($event) { return (selectMethod('crypto')); })
                                    }, _cache[20] || (_cache[20] = [
                                        _createElementVNode("img", {
                                            class: "img-fluid",
                                            src: "/imagenes/usdt.svg"
                                        }, null, -1)
                                    ]), 2)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                                (!isDone.value && paymentMethod.value === 'meru')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-secondary",
                                        style: { "max-width": "300px", "font-size": "0.86rem !important" },
                                        onClick: handleSubscribe
                                    }, "Continuar"))
                                    : _createCommentVNode("", true),
                                (!isDone.value && paymentMethod.value === 'meru')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, "Se le enviará por correo o whatsapp el enlace de pago."))
                                    : _createCommentVNode("", true),
                                (!isDone.value && paypalUrl.value !== null && paymentMethod.value === 'paypal')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createElementVNode("a", {
                                            href: paypalUrl.value,
                                            class: "btn btn-paypal d-inline-flex align-items-center"
                                        }, _cache[22] || (_cache[22] = [
                                            _createElementVNode("img", {
                                                src: "https://www.paypalobjects.com/webstatic/mktg/logo/pp_cc_mark_111x69.jpg",
                                                alt: "PayPal",
                                                width: "24",
                                                height: "24",
                                                class: "me-2"
                                            }, null, -1),
                                            _createElementVNode("span", null, "Pagar con PayPal", -1)
                                        ]), 8, _hoisted_39)
                                    ]))
                                    : _createCommentVNode("", true),
                                (!isDone.value && paymentMethod.value === 'crypto')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, "Próximamente."))
                                    : _createCommentVNode("", true),
                                (isDone.value)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_41, "Se verificará que su pago está realizado correctamente y se le notificará por correo y el sitio web."))
                                    : _createCommentVNode("", true),
                                (isDone.value)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 5,
                                        to: "/dashboard",
                                        class: "btn btn-link"
                                    }, {
                                        default: _withCtx(function () { return _cache[23] || (_cache[23] = [
                                            _createTextVNode("Ir al inicio")
                                        ]); }),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "text-center" }, "No hay pedidos pendientes", -1)),
                            _createElementVNode("div", _hoisted_43, [
                                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-muted text-center" }, "Si quieres realizar un pedido visita nuestro catálogo", -1)),
                                _createVNode(_component_router_link, {
                                    to: "/",
                                    class: "btn btn-primary",
                                    style: { "max-width": "420px" }
                                }, {
                                    default: _withCtx(function () { return _cache[24] || (_cache[24] = [
                                        _createTextVNode("Volver al inicio")
                                    ]); }),
                                    _: 1
                                })
                            ])
                        ]))
                ])
            ]));
        };
    }
});
